import { recycleWrappingPaperData } from "constants-lib/seo/recycleWrappingPaperData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getRecycleWrappingPaper = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Recycle Wrapping Paper JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addRecycleWrappingPaper = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/video-can-you-show-me-how-to-recycle-wrapping-paper`,
    ) &&
    document.getElementById(`recycleWrappingPaper`) === null
  ) {
    const script = recycleWrapppingPaperJSONLD()
    addJSONLDToHead(script, `recycleWrapppingPaper`)
  } else {
    removeElement(`recycleWrapppingPaper`)
  }
}

// JSON LD template for Recycle Wrapping Paper
const recycleWrapppingPaperJSONLD = () => {
  const recycleWrapppingPaperTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getRecycleWrappingPaper(recycleWrappingPaperData),
  }
  return recycleWrapppingPaperTemplate
}
